/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import CardSection from '../../../../components/ui/card/CardSection'
import Label from '../../../../components/finalForms/ui/label/Label'
import DropDown from '../../../../components/finalForms/ui/inputs/dropdown/DropDown'
import { useLazyGetAllUserQuery } from '../../../../app/services/userAPI'
import DatePicker from '../../../../components/ui/inputs/datePicker/DatePicker'
import Buttons from '../../../../components/ui/button/Buttons'
import FinalMolGrid from '../../../../components/FinalMolGrid/FinalMolGrid'
import { useExportExportGetAllEmployeeAuditReportMutation, useGetAllEmployeeAuditReportMutation } from '../../../../app/services/timesheetReportAPI'
import { saveAs } from 'file-saver';
import ToastService from '../../../../services/toastService/ToastService'
import formatDate from '../../../../components/FinalMolGrid/libs/formatDate'

const EmployeeAuditGridConfig = {
  columns: [
    {
      name: "User Name",
      fieldName: "userName",
      colStyle: {
        width: "25%",
        textAlign: "center",
      },

    },
    {
      name: "Start Date",
      fieldName: "startDate",
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },
    {
      name: "End Date",
      fieldName: "endDate",
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },
    {
      name: "Total Hours",
      fieldName: "totalHours",
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },
    {
      name: "Status",
      fieldName: "statusType",
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },
  ],
};

const EmployeeAuditReport = () => {

  const molGridRef = useRef();

  const [UserListData, setUserListData] = useState([]);
  const [userIdData, setUserIdData] = useState(null);
  const [monthData, setMonthData] = useState(new Date());
  const [dataSource, setDataSource] = useState([]);
  const [totalRowCount, setTotalRowCount] = useState(0);

  const year = monthData?.getFullYear();
  const month = monthData?.getMonth() + 1;

  //api call

  const [getAllUser, {
    isSuccess: isUserListSuccess,
    data: UserList
  },] = useLazyGetAllUserQuery();

  const [GetAllEmployeeAuditReport, {
    isLoading: isListLoading,
    isSuccess: isUserListEmployeeAudit,
    data: UserListEmployeeAudit
  },] = useGetAllEmployeeAuditReportMutation();

  const [exportGetAllEmployeeAuditReport, {
    isFetching: isExportGetAllEmployeeAuditReportFetching,
    isSuccess: isExportGetAllEmployeeAuditReportSuccess,
    data: ExportGetAllEmployeeAuditReport
  },] = useExportExportGetAllEmployeeAuditReportMutation();

  // useEffect

  useEffect(() => {
    getAllUser();
  }, [])

  useEffect(() => {
    if (isUserListSuccess && UserList) {
      const allOption = { label: "All", value: "0" };
      const mappedUserList = UserList.map(u => ({
        value: u.userId,
        label: u.userName,
      }));
      const updatedData = [allOption, ...mappedUserList];

      setUserListData(updatedData);
      setUserIdData(allOption);
    }
  }, [isUserListSuccess, UserList]);

  useEffect(() => {
    if (!isExportGetAllEmployeeAuditReportFetching && isExportGetAllEmployeeAuditReportSuccess && ExportGetAllEmployeeAuditReport) {
      let file = new Blob([ExportGetAllEmployeeAuditReport], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      if (ExportGetAllEmployeeAuditReport.size > 0) {
        saveAs(file, `Audit_Report_${formatDate(monthData, 'MMM-YYYY')}`);
      }
      else {
        ToastService.error("No Record Found is Selected Date");
      }
    }
  }, [isExportGetAllEmployeeAuditReportFetching, isExportGetAllEmployeeAuditReportSuccess, ExportGetAllEmployeeAuditReport]);

  useEffect(() => {
    if (isUserListEmployeeAudit && UserListEmployeeAudit) {
      if (UserListEmployeeAudit) {
        setDataSource(UserListEmployeeAudit.dataSource);
      }
      if (UserListEmployeeAudit.totalRecord) {
        setTotalRowCount(UserListEmployeeAudit.totalRecord);
      }
    }
  }, [isUserListEmployeeAudit, UserListEmployeeAudit]);

  const handleDownload = () => {
    const projectWiseRecord = molGridRef.current.getCurrentPageObject();
    if (projectWiseRecord) {
      const req = {
        userId: userIdData?.value ?? 0,
        year: year,
        month: month,
      }
      exportGetAllEmployeeAuditReport(req)
    }
  }

  const GetAllEmployeeAudit = (pageObject) => {
    GetAllEmployeeAuditReport(pageObject);
  };

  const handleUserChange = (selectedOption) => {
    setUserIdData(selectedOption);
  };

  const handaleMonthChange = (date) => {
    setMonthData(date);
  }

  const handleGetRecord = () => {
    if (molGridRef.current) {

      const currentPageObject = molGridRef.current.getCurrentPageObject();
      const request = {
        pagination: {
          pageNumber: currentPageObject.pageNumber,
          pageSize: currentPageObject.pageSize,
        },
        userId: userIdData?.value || 0,
        month: month,
        year: year,

      };

      GetAllEmployeeAudit(request);
    }
  }

  const handlePageChange = (page) => {
    const request = {
      pagination: { pageNumber: page.pageNumber, pageSize: page.pageSize },
      userId: userIdData?.value || 0,
      month: month,
      year: year,
    };
    GetAllEmployeeAudit(request);
  };

  return (
    <div className='mt-2'>
      <CardSection
        cardTitle={'Employee Audit Report'}
      >
        <div className='row'>
          <div className='col-lg-4 '>
            <Label labelName="Select User" />
            <DropDown
              placeholder="Select User"
              options={UserListData}
              value={userIdData?.value}
              onChange={(e) => handleUserChange(e)}
            />
          </div>
          <div className='col-lg-3 '>
            <Label className="timesheet-report-userwise" labelName="Select Date" isRequired={true} />
            <DatePicker
              selected={monthData}
              onChange={handaleMonthChange}
              datePickerConfig={{
                isMonthPicker: true,
                dateFormat: "MMMM yyyy",
              }}
            />
          </div>
          <div className='col-lg-2 d-flex gap-2 mt-3 p-1'>
            <Buttons
              buttonTypeClassName="btn theme-btn"
              textWithIcon={true}
              fontIcon={true}
              iconName={'material-symbols:search-rounded'}
              buttonText="Search"
              isDisable={monthData == null}
              onClick={handleGetRecord}
            />
            <Buttons
              buttonTypeClassName="success-btn"
              textWithIcon={true}
              fontIcon={true}
              isDisable={!dataSource?.length}
              iconName={'ph:export'}
              buttonText="Export"
              onClick={handleDownload}
            />
          </div>
        </div>
        <div className='mt-2 head-center'>
          <FinalMolGrid
            ref={molGridRef}
            configuration={EmployeeAuditGridConfig}
            dataSource={dataSource}
            allowPagination={true}
            pagination={{
              totalCount: totalRowCount,
              pageSize: 50,
              currentPage: 1,
            }}
            isLoading={isListLoading}
            onPageChange={handlePageChange}
          />
        </div>
      </CardSection>
    </div>
  )
}

export default EmployeeAuditReport